import { render, staticRenderFns } from "./refund-order-detail.vue?vue&type=template&id=4603a66f&scoped=true&"
import script from "./refund-order-detail.vue?vue&type=script&lang=js&"
export * from "./refund-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./refund-order-detail.vue?vue&type=style&index=0&id=4603a66f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4603a66f",
  null
  
)

export default component.exports